import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';
import { IBussinesForUpdate } from '../../Types/business';

export async function getCompany() {
  return fetchWrapper(endpoint + '/v1/company').then((res) => res.json());
}

export async function updateCompany(companyInfo: IBussinesForUpdate) {
  return fetchWrapper(endpoint + `/v1/company`, {
    method: 'put',
    body: JSON.stringify(companyInfo),
  });
}
